import React from "react";

/* eslint-disable max-len */
export default function SlidePrevButtonFocus() {
    return (
        <svg version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px"
			y="0px" viewBox="0 0 17.1 20.7" enableBackground="new 0 0 17.1 20.7" xmlSpace="preserve">
		<g>
			<path opacity="0.6" fill="#64696D" stroke="#232323" strokeWidth="0.9798" strokeMiterlimit="10" d="M2.6,20.1h11.8
				c1.1,0,2-0.9,2-2V2.6c0-1.1-0.9-2-2-2H2.6c-1.1,0-2,0.9-2,2v15.5C0.6,19.2,1.5,20.1,2.6,20.1z"/>
			<g>
				<line fill="none" stroke="#FFFFFF" strokeLinecap="round" strokeMiterlimit="10" x1="11.1" y1="4.9" x2="5.6" y2="10.3"/>
				<line fill="none" stroke="#FFFFFF" strokeLinecap="round" strokeMiterlimit="10" x1="5.6" y1="10.3" x2="11.1" y2="15.8"/>
			</g>
		</g>
		</svg>
    );
}
